<template>
  <div class="content">
    <Header></Header>
    <div class="main" v-show="this.isApp == true ? false : true">
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="navigation-con">
          <div class="navigation">
          {{ $t("teaching.home") }}>>{{ $t("buy.t4")}}
          </div>
          <div class="jiaoyi" @click="getTransaction">{{$t('gift.t2')}}</div>
        </div>
        <div class="main-pad-gift">
          <div>
            <!-- <div class="payList-item" v-for="(item,index) in payList" :key="index">
              <div><img class="payList-img" :src="item.image" alt=""></div>
              <div class="payList-title">{{item.title}}</div>
            </div> -->
            <div>
              <div class="payList-item" @click="showBank">
                <div class="payList-con">
                  <img
                    class="payList-img"
                    src="../assets/index/yinghang.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t1") | toDa }}</div>
                </div>
              </div>
              <div class="zan-con" v-show="isBank">
                <div class="payChoice-con">
                  <div class="bank-options">{{ $t("buy.t5") | toDa }}</div>
                  <div class="bank-select">{{ $t("buy.t6") }}</div>
                  <div class="bank-con">
                    <div
                      class="bank-item"
                      v-for="(item, index) in bankList"
                      :key="index"
                      @click="choiceBank(item, index)"
                    >
                      <img
                        :class="cieBank == index ? 'bank-img-sub' : 'bank-img'"
                        :src="item.ico"
                        alt=""
                      />
                      <!-- <img
                        :class="cieBank == index ? 'bank-img-sub' : 'bank-img'"
                        src="https://file.royale8w.com/bank/09ff66bfff4e7663d013b4f61140967e.png"
                        alt=""
                      /> -->
                    </div>
                  </div>
                  <div
                    class="ifm-con"
                    v-show="this.isNull == true ? true : false"
                  >
                    <div class="ifm-top">
                      <span class="ifm-name">{{ bankIfm.receiving_bank }}</span>
                      {{ $t("buy.t7") }}
                    </div>
                    <div class="ifm-item">
                      <div>{{ $t("buy.t8") }}</div>
                      <div class="ifm-title">{{ bankIfm.beneficiary }}</div>
                    </div>
                    <div class="ifm-item">
                      <div>{{ $t("buy.t9") }}</div>
                      <div class="ifm-title">
                        <span class="bank-accounts_receivable">{{
                          bankIfm.accounts_receivable
                        }}</span>
                        <!-- <i class="el-icon-document-copy"></i> -->
                      </div>
                    </div>
                    <div class="ifm-item">
                      <div>{{ $t("buy.t10") }}</div>
                      <div class="ifm-title">10.00/100,000.00</div>
                    </div>
                  </div>
                </div>

                <div class="payChoice-con">
                  <div class="bank-options">{{ $t("buy.t11") | toDa }}</div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t12") }}</div>
                    <div class="rechargeAmount-ischoiceAct">
                      {{ ischoiceAct }}
                    </div>
                    <div class="rechargeAmount-con">
                      <div
                        class="rechargeAmount-item"
                        v-for="(item, index) in rechargeAmount"
                        :key="index"
                        @click="choiceAct(item, index)"
                      >
                        <div class="rechargeAmount-price">{{ item.price }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t13") }}</div>
                    <div>
                      <el-select
                        v-model="isdptMethod"
                        :placeholder="this.isdptMethod"
                        @change="dptChange"
                      >
                        <el-option
                          v-for="item in dptOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t14") }}</div>
                    <div class="time-con">
                      <div>
                        <input
                          class="time-con-input"
                          type="text"
                          v-model="nowTime"
                          placeholder="XXXX-XX-XX"
                          maxlength="10"
                        />
                      </div>
                      <div class="choice-time-con">
                        <el-select v-model="ishour" :placeholder="this.ishour">
                          <el-option
                            v-for="item in hourList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="choice-time-con">
                        <el-select
                          v-model="isminute"
                          :placeholder="this.isminute"
                        >
                          <el-option
                            v-for="item in minuteList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <!-- <div class="choice-time-con">
                        <el-select v-model="isapm" :placeholder="this.isapm">
                          <el-option
                            v-for="item in apmList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div> -->
                      <div @click="test"><i class="el-icon-date"></i></div>
                    </div>
                    <div class="time-tip" v-show="isTimetips">{{ $t("buy.t36") }}</div>
                  </div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t15") }}</div>
                    <div>
                      <input
                        class="reference-input"
                        type="text"
                        v-model="isreference"
                      />
                    </div>
                  </div>
                  <!-- <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t16") }}</div>
                    <el-upload
                      class="upload-demo"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :on-success="handleAvatarSuccess"
                      multiple
                      :limit="1"
                      :show-file-list="true"
                      :on-remove="handleRemove"
                    >
                      <div class="receipt">
                        <div class="rechargeAmount-ischoiceAct">
                          {{ $t("buy.t17") }}
                        </div>
                        <div><i class="el-icon-document"></i></div>
                      </div>
                    </el-upload>
                  </div> -->
                </div>
                <div class="payChoice-con">
                  <div class="bank-options">{{ $t("buy.t18") | toDa }}</div>
                  <div class="promotions-con">
                    <img
                      @click="choicePromo"
                      :class="
                        this.ispromo == true
                          ? 'promotions-img-sub'
                          : 'promotions-img'
                      "
                      src="../assets/index/baifenzhi.png"
                      alt=""
                    />
                  </div>
                  <el-checkbox v-model="isagree"
                    ><div class="czdetails-title">
                      {{ $t("buy.t20") }}
                    </div></el-checkbox
                  >
                  <div class="btm-con">
                    <div class="btm-reset" @click="goReset">
                      {{ $t("buy.t21") }}
                    </div>
                    <div class="btm-reset" @click="submitBank">
                      {{ $t("buy.t22") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="payList-item" @click="showQuickpay">
                <div class="payList-con">
                  <img
                    class="payList-img"
                    src="../assets/index/quick_pay.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t2") | toDa }}</div>
                </div>
              </div>
              <div class="quickPay-con" v-show="isQuickpay">
                <div>
                  <div class="bank-select">{{ $t("buy.t24") }}</div>
                </div>
                <div class="quickPayList-con">
                  <div class="promotions-con-sub">
                                      <div
                    class="promotions-con"
                    v-for="(item, index) in luckPayList"
                    :key="index"
                  >
                    <!-- <img class="quickPayList-img" :src="quickPayList.ico" alt=""> -->
                    <img
                      @click="cieQuickPay(item, index)"
                      :class="
                        isquickpayImg == index
                          ? 'quickPayList-img-sub'
                          : 'quickPayList-img'
                      "
                      :src="item.ico"
                      alt=""
                    />
                  </div>
                  </div>
                  <div v-show="isquickpayImg == -1 ? false : true">
                    <div class="line"></div>
                    <div class="bank-options">{{ $t("buy.t25") | toDa }}</div>
                    <div class="limit-con">
                      <span class="czdetails-title">{{ $t("buy.t26") }}</span>
                      <span class="quickPayList-limit"
                        >({{ $t("buy.t10") }}:10.00/100,000.00)</span
                      >
                    </div>
                    <div class="rechargeAmount-ischoiceAct">
                      {{ ischoiceActQck }}
                    </div>
                    <div class="rechargeAmount-con">
                      <div
                        class="rechargeAmount-item"
                        v-for="(item, index) in quickAmount"
                        :key="index"
                        @click="choiceActQck(item, index)"
                      >
                        <div class="rechargeAmount-price">{{ item.price }}</div>
                      </div>
                    </div>
                    <div class="line-sub"></div>
                    <div class="payChoice-con">
                      <div class="bank-options">{{ $t("buy.t18") | toDa }}</div>
                      <div class="promotions-con">
                        <img
                          @click="choicePromoQck"
                          :class="
                            this.ispromoQck == true
                              ? 'promotions-img-sub'
                              : 'promotions-img'
                          "
                          src="../assets/index/baifenzhi.png"
                          alt=""
                        />
                      </div>
                      <el-checkbox v-model="isagreeQck"
                        ><div class="czdetails-title">
                          {{ $t("buy.t20") }}
                        </div></el-checkbox
                      >
                      <div class="btm-con">
                        <div class="btm-reset" @click="goResetQck">
                          {{ $t("buy.t21") }}
                        </div>
                        <div class="btm-reset" @click="submitQuickPay">
                          {{ $t("buy.t22") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="payList-item" @click="showCurrency">
                <div class="payList-con">
                  <img
                    class="payList-img-sub"
                    src="../assets/index/swiftcoin.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t3") | toDa }}</div>
                </div>
              </div>
              <Currency v-show="isCurrency"></Currency>
            </div>

            <div>
              <!-- <div class="payList-item" @click="goCardPay">
                <div class="payList-con">
                  <img
                    class="payList-img-sub"
                    src="../assets/index/credit.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t37") | toDa }}</div>
                </div>
              </div> -->
              <Currency v-show="isCurrency"></Currency>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="main-h5" v-show="this.isApp == false ? false : true">
      <!-- <MainLeft></MainLeft> -->
      <div class="main_content-h5">
        <div class="navigation-con">
          <div class="navigation">
          {{ $t("teaching.home") }}>>{{ $t("buy.t4")}}
          </div>
          <div class="jiaoyi" @click="getTransaction">{{$t('gift.t2')}}</div>
        </div>
        <div class="main-pad-gift">
          <div>
            <div>
              <div class="payList-item" @click="showBank">
                <div class="payList-con">
                  <img
                    class="payList-img"
                    src="../assets/index/yinghang.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t1") | toDa }}</div>
                </div>
              </div>
              <div class="zan-con" v-show="isBank">
                <div class="payChoice-con">
                  <div class="bank-options">{{ $t("buy.t5") | toDa }}</div>
                  <div class="bank-select">{{ $t("buy.t6") }}</div>
                  <div class="bank-con">
                    <div
                      class="bank-item-h5"
                      v-for="(item, index) in bankList"
                      :key="index"
                      @click="choiceBank(item, index)"
                    >
                      <!-- <img :class="cieBank == index? 'bank-img-sub':'bank-img'" :src="item.ico" alt=""> -->
                      <img
                        :class="cieBank == index ? 'bank-img-sub-h5' : 'bank-img-h5'"
                        :src="item.ico"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    class="ifm-con"
                    v-show="this.isNull == true ? true : false"
                  >
                    <div class="ifm-top">
                      <span class="ifm-name">{{ bankIfm.receiving_bank }}</span>
                      {{ $t("buy.t7") }}
                    </div>
                    <div class="ifm-item-h5">
                      <div>{{ $t("buy.t8") }}</div>
                      <div class="ifm-title">{{ bankIfm.beneficiary }}</div>
                    </div>
                    <div class="ifm-item-h5">
                      <div>{{ $t("buy.t9") }}</div>
                      <div class="ifm-title">
                        <span class="bank-accounts_receivable">{{
                          bankIfm.accounts_receivable
                        }}</span>
                        <!-- <i class="el-icon-document-copy"></i> -->
                      </div>
                    </div>
                    <div class="ifm-item-h5">
                      <div>{{ $t("buy.t10") }}</div>
                      <div class="ifm-title">10.00/100,000.00</div>
                    </div>
                  </div>
                </div>

                <div class="payChoice-con">
                  <div class="bank-options">{{ $t("buy.t11") | toDa }}</div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t12") }}</div>
                    <div class="rechargeAmount-ischoiceAct">
                      {{ ischoiceAct }}
                    </div>
                    <div class="rechargeAmount-con">
                      <div
                        class="rechargeAmount-item"
                        v-for="(item, index) in rechargeAmount"
                        :key="index"
                        @click="choiceAct(item, index)"
                      >
                        <div class="rechargeAmount-price">{{ item.price }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t13") }}</div>
                    <div>
                      <el-select
                        v-model="isdptMethod"
                        :placeholder="this.isdptMethod"
                        @change="dptChange"
                      >
                        <el-option
                          v-for="item in dptOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t14") }}</div>
                    <div class="time-con">
                      <div>
                        <input
                          class="time-con-input"
                          type="text"
                          v-model="nowTime"
                          placeholder="XXXX-XX-XX"
                          maxlength="10"
                        />
                      </div>
                      <div class="choice-time-con">
                        <el-select v-model="ishour" :placeholder="this.ishour">
                          <el-option
                            v-for="item in hourList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div class="choice-time-con">
                        <el-select
                          v-model="isminute"
                          :placeholder="this.isminute"
                        >
                          <el-option
                            v-for="item in minuteList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <!-- <div class="choice-time-con">
                        <el-select v-model="isapm" :placeholder="this.isapm">
                          <el-option
                            v-for="item in apmList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div> -->
                      <div @click="test"><i class="el-icon-date"></i></div>
                    </div>
                    <div class="time-tip" v-show="isTimetips">{{ $t("buy.t36") }}</div>
                  </div>
                  <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t15") }}</div>
                    <div>
                      <input
                        class="reference-input"
                        type="text"
                        v-model="isreference"
                      />
                    </div>
                  </div>
                  <!-- <div class="czdetails">
                    <div class="czdetails-title">{{ $t("buy.t16") }}</div>
                    <el-upload
                      class="upload-demo"
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :on-success="handleAvatarSuccess"
                      multiple
                      :limit="1"
                      :show-file-list="true"
                      :on-remove="handleRemove"
                    >
                      <div class="receipt">
                        <div class="rechargeAmount-ischoiceAct">
                          {{ $t("buy.t17") }}
                        </div>
                        <div><i class="el-icon-document"></i></div>
                      </div>
                    </el-upload>
                  </div> -->
                </div>
                <div class="payChoice-con">
                  <div class="bank-options">{{ $t("buy.t18") | toDa }}</div>
                  <div class="promotions-con">
                    <img
                      @click="choicePromo"
                      :class="
                        this.ispromo == true
                          ? 'promotions-img-sub-h5'
                          : 'promotions-img-h5'
                      "
                      src="../assets/index/baifenzhi.png"
                      alt=""
                    />
                  </div>
                  <el-checkbox v-model="isagree"
                    ><div class="czdetails-title">
                      {{ $t("buy.t20") }}
                    </div></el-checkbox
                  >
                  <div class="btm-con">
                    <div class="btm-reset" @click="goReset">
                      {{ $t("buy.t21") }}
                    </div>
                    <div class="btm-reset" @click="submitBank">
                      {{ $t("buy.t22") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="payList-item" @click="showQuickpay">
                <div class="payList-con">
                  <img
                    class="payList-img"
                    src="../assets/index/quick_pay.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t2") | toDa }}</div>
                </div>
              </div>
               <div class="quickPay-con" v-show="isQuickpay">
                <div>
                  <div class="bank-select">{{ $t("buy.t24") }}</div>
                </div>
                <div class="quickPayList-con">
                  <div class="promotions-con-sub">
                                      <div
                    class="promotions-con"
                    v-for="(item, index) in luckPayList"
                    :key="index"
                  >
                    <!-- <img class="quickPayList-img" :src="quickPayList.ico" alt=""> -->
                    <img
                      @click="cieQuickPay(item, index)"
                      :class="
                        isquickpayImg == index
                          ? 'quickPayList-img-sub-h5'
                          : 'quickPayList-img-h5'
                      "
                      :src="item.ico"
                      alt=""
                    />
                  </div>
                  </div>
                  <div v-show="isquickpayImg == -1 ? false : true">
                    <div class="line"></div>
                    <div class="bank-options">{{ $t("buy.t25") | toDa }}</div>
                    <div class="limit-con">
                      <span class="czdetails-title">{{ $t("buy.t26") }}</span>
                      <span class="quickPayList-limit"
                        >({{ $t("buy.t10") }}:10.00/100,000.00)</span
                      >
                    </div>
                    <div class="rechargeAmount-ischoiceAct">
                      {{ ischoiceActQck }}
                    </div>
                    <div class="rechargeAmount-con">
                      <div
                        class="rechargeAmount-item"
                        v-for="(item, index) in quickAmount"
                        :key="index"
                        @click="choiceActQck(item, index)"
                      >
                        <div class="rechargeAmount-price">{{ item.price }}</div>
                      </div>
                    </div>
                    <div class="line-sub"></div>
                    <div class="payChoice-con">
                      <div class="bank-options">{{ $t("buy.t18") | toDa }}</div>
                      <div class="promotions-con">
                        <img
                          @click="choicePromoQck"
                          :class="
                            this.ispromoQck == true
                              ? 'promotions-img-sub-h5'
                              : 'promotions-img-h5'
                          "
                          src="../assets/index/baifenzhi.png"
                          alt=""
                        />
                      </div>
                      <el-checkbox v-model="isagreeQck"
                        ><div class="czdetails-title">
                          {{ $t("buy.t20") }}
                        </div></el-checkbox
                      >
                      <div class="btm-con">
                        <div class="btm-reset" @click="goResetQck">
                          {{ $t("buy.t21") }}
                        </div>
                        <div class="btm-reset" @click="submitQuickPay">
                          {{ $t("buy.t22") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="payList-item" @click="showCurrency">
                <div class="payList-con">
                  <img
                    class="payList-img-sub"
                    src="../assets/index/swiftcoin.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t3") | toDa }}</div>
                </div>
              </div>
              <!-- <div class="payList-item" @click="goCardPay">  //信用卡支付
                <div class="payList-con">
                  <img
                    class="payList-img-sub"
                    src="../assets/index/credit.png"
                    alt=""
                  />
                  <div class="payList-title">{{ $t("buy.t37") | toDa }}</div>
                </div>
              </div> -->
              <Currency v-show="isCurrency"></Currency>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Login-pop ref="LoginPop"></Login-pop>
    <Footer></Footer>
    <My-popup
      :popupMsg="popupMsg"
      @handlePopup="handleShowOrHidePopup"
      v-show="showPopup"
    />
    <router-view></router-view>
  </div>
</template>
<script>
import myPopup from "../components/myPopup.vue";
import Currency from "../components/currency.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import LoginPop from "../components/loginPop";
import "../assets/h5/buy.css";
export default {
  components: { LoginPop, myPopup, Currency },
  filters: {
    toDa(value) {
      return value.toUpperCase();
    },
  },
  data() {
    return {
      isTimetips:false,
      isCurrency: false,
      isQuickpay: false,
      isBank: false,
      isreference: "",
      isNull: false,
      fileList: [], //上传凭证
      ischoiceAct: "",
      ischoiceActQck: "",
      cieBank: -1,
      visible: false,
      isLoginShow: true,
      bankList: [],
      bankIfm: {},
      rechargeAmount: [],
      dptOptions: [
        {
          value: "1",
          label: this.$t("buy.t28"),
        },
        {
          value: "2",
          label: this.$t("buy.t29"),
        },
        {
          value: "3",
          label: this.$t("buy.t30"),
        },
      ],
      hourList: [
        { value: "01", label: "01" },
        { value: "02", label: "02" },
        { value: "03", label: "03" },
        { value: "04", label: "04" },
        { value: "05", label: "05" },
        { value: "06", label: "06" },
        { value: "07", label: "07" },
        { value: "08", label: "08" },
        { value: "09", label: "09" },
        { value: "10", label: "10" },
        { value: "11", label: "11" },
        { value: "12", label: "12" },
        { value: "13", label: "13" },
        { value: "14", label: "14" },
        { value: "15", label: "15" },
        { value: "16", label: "16" },
        { value: "17", label: "17" },
        { value: "18", label: "18" },
        { value: "19", label: "19" },
        { value: "20", label: "20" },
        { value: "21", label: "21" },
        { value: "22", label: "22" },
        { value: "23", label: "23" },
        { value: "24", label: "24" },
      ],
      minuteList: [
        { value: "00", label: "00" },
        { value: "01", label: "01" },
        { value: "02", label: "02" },
        { value: "03", label: "03" },
        { value: "04", label: "04" },
        { value: "05", label: "05" },
        { value: "06", label: "06" },
        { value: "07", label: "07" },
        { value: "08", label: "08" },
        { value: "09", label: "09" },
        { value: "10", label: "10" },
        { value: "11", label: "11" },
        { value: "12", label: "12" },
        { value: "13", label: "13" },
        { value: "14", label: "14" },
        { value: "15", label: "15" },
        { value: "16", label: "16" },
        { value: "17", label: "17" },
        { value: "18", label: "18" },
        { value: "19", label: "19" },
        { value: "20", label: "20" },
        { value: "21", label: "21" },
        { value: "22", label: "22" },
        { value: "23", label: "23" },
        { value: "24", label: "24" },
        { value: "25", label: "25" },
        { value: "26", label: "26" },
        { value: "27", label: "27" },
        { value: "28", label: "28" },
        { value: "29", label: "29" },
        { value: "30", label: "30" },
        { value: "31", label: "31" },
        { value: "32", label: "32" },
        { value: "33", label: "33" },
        { value: "34", label: "34" },
        { value: "35", label: "35" },
        { value: "36", label: "36" },
        { value: "37", label: "37" },
        { value: "38", label: "38" },
        { value: "39", label: "39" },
        { value: "40", label: "40" },
        { value: "41", label: "41" },
        { value: "42", label: "42" },
        { value: "43", label: "43" },
        { value: "44", label: "44" },
        { value: "45", label: "45" },
        { value: "46", label: "46" },
        { value: "47", label: "47" },
        { value: "48", label: "48" },
        { value: "49", label: "49" },
        { value: "50", label: "50" },
        { value: "51", label: "51" },
        { value: "52", label: "52" },
        { value: "53", label: "53" },
        { value: "54", label: "54" },
        { value: "55", label: "55" },
        { value: "56", label: "56" },
        { value: "57", label: "57" },
        { value: "58", label: "58" },
        { value: "59", label: "59" },
      ],
      isdptMethod: "",
      ishour: "",
      isminute: "",
      // isapm: "",
      isnum: "1",
      ispromo: false, //是否选择折扣
      ispromoQck: false, //是否选择折扣Quickpay
      isagree: false,
      isagreeQck: false,
      quickPayList: [],
      isquickpayImg: -1,
      quickAmount: [],
      iscieqck: "1",
      paytypeBank: 0,
      paytypeQuickpay: 5,
      receivingBank: "",
      beneficiaryBank: "",
      accountsReceivableBank: "",
      transferType: 1,
      joinGive: "",
      joinGiveQck: "",
      showPopup: false,
      popupMsg: {
        title: "",
        content: "",
        // cancel:'取消',
        confirm: "ok",
      },
      luckPayList: [],
      isDiscount:0,
      isDiscountBank:0,
      nowTime:'',
    };
  },
  created() {
    this.dptMethod();
    this.getBankList();
    this.getNowTime()

    this.getRechargeType()
  },
  mounted() {
    this.isLogin();
  },
  computed: {
    ...mapState({
      hasLogin(state) {
        return state.hasLogin;
      },
      isApp(state) {
        return state.isApp;
      },
      tokenData(state){
        return state.tokenData;
      }
    }),
  },
  methods: {
    getNowTime() {
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var time = y + "-" + m + "-" + d;
      this.nowTime = time
    },
    showCurrency() {
      this.isCurrency = !this.isCurrency;
    },
    handleShowOrHidePopup: function (type) {
      if (type == "yes") {
        // console.log(type)
        this.showPopup = false;
        // location.reload();
      } else {
        // console.log(type)
        this.showPopup = false;
        // location.reload();
      }
    },
    dptChange(e) {
      if (e == 1) {
        this.transferType = 3;
      }
      if (e == 2) {
        this.transferType = 2;
      }
      if (e == 3) {
        this.transferType = 1;
      }
    },
    test() {
      //  let routeData = "https://www.rwinvip.com/my/deposit"
      //     window.open(routeData, "_blank");
    },
    //获取银行列表接口
    getBankList() {
      var _that = this;
      let obj = {
        token:_that.tokenData
      };
      this.$FucPost(this.$store.state.ip + "/getBankList", obj)
        .then(function (res) {
          // console.log("getBankList-res", res);
          let resData = res.data;
          _that.bankList = resData.banklist;

          _that.rechargeAmount = resData.shop_item;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isLogin() {
      if (this.hasLogin == "1") {
        // console.log("--22--");
        this.$refs.LoginPop.showLogin();
      }
    },
    choiceBank(e, index) {
      this.isNull = true;
      this.cieBank = index;
      this.bankIfm = e;
      // console.log("e", e);
      this.paytypeBank = e.paytype;
      this.receivingBank = e.receiving_bank;
      this.beneficiaryBank = e.beneficiary;
      this.accountsReceivableBank = e.accounts_receivable;
    },
    choiceAct(e, index) {
      // console.log("e", e);
      this.ischoiceAct = e.price;
      this.joinGive = e.join_give;
      // this.receivingBank = e.receiving_bank
    },
    choiceActQck(e, index) {
      // console.log("e", e);
      this.joinGiveQck = e.join_give;
      this.ischoiceActQck = e.price;
    },
    dptMethod() {
      this.isdptMethod = this.dptOptions[0].label;
      this.ishour = this.hourList[0].label;
      this.isminute = this.minuteList[0].label;
      // this.isapm = this.apmList[0].label;
    },
    //线下打折选项
    choicePromo() {
      this.isnum++;
      // console.log("this.isnum", this.isnum);
      if (this.isnum % 2 == 0) {
        this.ispromo = true;
        this.isDiscountBank = 1
      } else {
        this.ispromo = false;
        this.isDiscountBank = 0

      }
    },
    //线上打折选项
    choicePromoQck() {
      this.isnum++;
      // console.log("this.isnum", this.isnum);
      if (this.isnum % 2 == 0) {
        this.ispromoQck = true;
        this.isDiscount = 1
      } else {
        this.ispromoQck = false;
        this.isDiscount = 0

      }
    },
    handleAvatarSuccess(res, file, fileList) {
      alert("Uploaded successfully~");
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    goReset() {  //重置
      this.getNowTime()
      this.cieBank = -1;
      this.isNull = false;
      this.ischoiceAct = "";
      this.isdptMethod = this.dptOptions[0].label;
      this.ishour = this.hourList[0].label;
      this.isminute = this.minuteList[0].label;
      this.isapm = this.apmList[0].label;
      this.isreference = "";
      this.ispromo = false;
      this.isagree = false;
    },
    goResetQck() {
      // this.quickpayImg = false
      this.ispromoQck = false;
      this.isagreeQck = false;
      this.ischoiceActQck = "";
    },
    showBank() {
      this.isBank = !this.isBank;
    },
    showQuickpay() {
      //newgai
      // this.getQuickPay();
      this.getRechargeType()
      this.isQuickpay = !this.isQuickpay;
    },
    //获取线上支付接口
    // getQuickPay() {
    //   var _that = this;
    //   let obj = {
    //     token:_that.tokenData
    //   };
    //   this.$FucPost(this.$store.state.ip + "/getQuickPay", obj)
    //     .then(function (res) {
    //       // console.log("getQuickPay-res", res);
    //       let resData = res.data.luck_pay_recharge;
    //       _that.luckPayList = resData;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    //newgai
    getRechargeType() {
      var _that = this;
      let obj = {
        token:_that.tokenData
      };
      this.$FucPost(this.$store.state.ip + "/getRechargeType", obj)
        .then(function (res) {
          // console.log("getRechargeType-res", res);
          // let resData = res.data.luck_pay_recharge;
          _that.luckPayList = res.data.luck_pay_recharge;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cieQuickPay(e, index) {
      this.isquickpayImg = index;
      // console.log("e", e);
      // this.quickAmount = e.shop_item;    //newgai
      this.paytypeQuickpay = e.paytype;
      this.getRechargeItem()
    },
    
    //newgai
    getRechargeItem(){
      var _that = this;
      let obj = {
        token:_that.tokenData,
        pay_type:this.paytypeQuickpay
      };
      this.$FucPost(this.$store.state.ip + "/getRechargeItem", obj)
        .then(function (res) {
          // console.log("getRechargeItem-res", res);
          let resData = res.data;
          _that.quickAmount = resData.shop_item;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkDate(dateStr){
            var a = /^(\d{4})-(\d{2})-(\d{2})$/
            if (!a.test(dateStr)) {
                return false
            }else{
                return true;
            }
    },
    //提交线下支付
    submitBank() {  
      var nowTime = this.nowTime
      var re = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (this.isagree == false) {
        alert(this.$t("buy.t27"));
      }
      if(!re.test(nowTime)){
        this.isTimetips = true
      }
      if(this.isagree != false && re.test(nowTime)) {
        var _that = this;
        _that.isTimetips = false
        let obj = {
          price: _that.ischoiceAct,
          paytype: _that.paytypeBank,
          receivingBank: _that.receivingBank,
          beneficiary: _that.beneficiaryBank,
          accountsReceivable: _that.accountsReceivableBank,
          transfer_time:
            _that.nowTime + " " + _that.ishour + ":" + _that.isminute + ":00",
          transfer_type: _that.transferType,
          check_code: 1234,
          join_give: _that.joinGive,
          discount:_that.isDiscountBank,
          token:_that.tokenData
        };
        this.$FucPost(this.$store.state.ip + "/offlinePay", obj)
          .then(function (res) {
            // console.log("offlinePay-res", res);
            if (res.code != 200) {
              _that.showPopup = true;
              _that.popupMsg.content = res.msg;
            }
            if (res.code == 200) {
              _that.showPopup = true;
              _that.popupMsg.content = res.msg;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    submitQuickPay() {
      //提交线上支付获取线上支付链接
      if (this.isagreeQck == false) {
        alert(this.$t("buy.t27"));
      } else {
        var _that = this;
        let obj = {
          price: _that.ischoiceActQck,
          paytype: _that.paytypeQuickpay,
          join_give: _that.joinGiveQck,
          discount:_that.isDiscount,
          token:_that.tokenData
        };
        this.$FucPost(this.$store.state.ip + "/getQuickPayUrl", obj)
          .then(function (res) {
            // console.log("getQuickPayUrl-res", res);
            if (res.code != 200) {
              _that.showPopup = true;
              _that.popupMsg.content = res.msg;
            }
            if (res.code == 200) {
              _that.showPopup = true;
              _that.popupMsg.content = "Please enter the jump link and pay~";
              let routeData = res.payurl;
              window.open(routeData, "_blank");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getTransaction(){
        this.$router.push({
          name:"gift",
          query:{
            jumpNum:"1",
          }
        })
    },
    goCardPay(){
      window.open("https://www.6800w.com/","_blank")
    }
  },
};
</script>
<style lang="less" scoped>
/deep/.el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 0.25rem;
  border: 0.0625rem solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 1.875rem;
  line-height: 1.875rem;
  outline: 0;
  padding: 0 0.9375rem;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  margin: 0;
}
/deep/ .el-icon-close-tip {
  display: none;
}
/deep/ .el-checkbox {
  color: #fff;
}
</style>
